import { Button } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import WorkCostForm, { IWorkCostData } from "../../../common/controls/WorkCostForm";
import moment from 'moment';
import * as Guid from '../../../common/utils/Guid'
import clsx from "clsx";

export interface IProps {
	refControl: string,
	errorText: string,
	onSet?: (value: IWorkCostData) => void,
	name: string,
	open: boolean,
	editUser: boolean,
}

export default function WorkCostExpandableForm(props: IProps) {
	const [open, setOpen] = React.useState(props.open);
	const { t } = useTranslation();
	const [value, setValue] = React.useState<IWorkCostData>(null);

	const idControlRef = React.useRef<HTMLInputElement>();
	const dateControlRef = React.useRef<HTMLInputElement>();
	const timeControlRef = React.useRef<HTMLInputElement>();
	const workTypeControlRef = React.useRef<HTMLInputElement>();
	const additionalCostControlRef = React.useRef<HTMLInputElement>();
	const descriptionControlRef = React.useRef<HTMLInputElement>();

	const userIdControlRef = React.useRef<HTMLInputElement>();
	const userLabelControlRef = React.useRef<HTMLInputElement>();

	React.useEffect(() => {
		idControlRef.current = document.querySelector("input[data-ref='" + props.refControl + "_id']");
		dateControlRef.current = document.querySelector("input[data-ref='" + props.refControl + "_date']");
		timeControlRef.current = document.querySelector("input[data-ref='" + props.refControl + "_time']");
		workTypeControlRef.current = document.querySelector("input[data-ref='" + props.refControl + "_workType']");
		additionalCostControlRef.current = document.querySelector("input[data-ref='" + props.refControl + "_additionalCost']");
		descriptionControlRef.current = document.querySelector("input[data-ref='" + props.refControl + "_description']");

		userIdControlRef.current = document.querySelector("input[data-ref='" + props.refControl + "_userId']");
		userLabelControlRef.current = document.querySelector("input[data-ref='" + props.refControl + "_userLabel']");

		let newV: IWorkCostData = {
			additionalCost: additionalCostControlRef.current.value,
			date: null,
			description: descriptionControlRef.current.value,
			time: timeControlRef.current.value,
			workType: workTypeControlRef.current.value,
			user: null,
		};

		if (dateControlRef.current.value) {
			newV.date = moment(dateControlRef.current.value);
		}

		if (userIdControlRef.current.value && userIdControlRef.current.value != Guid.Empty) {
			newV.user = {
				label: userLabelControlRef.current.value,
				value: userIdControlRef.current.value,
			}
		}
		setValue(newV);
		if (props.onSet)
			props.onSet(newV);
		
	}, []);

	return (<div>
		<div className={clsx("btn-group separator btn-set", open && "btn-beak")}>
			<span className={clsx(open && "active")}>
				<Button variant="outlined" color={props.errorText ? "secondary" : "default" } onClick={() => setOpen(!open)} >
					{t("control.workCost.addWorkCost")}
				</Button>
			</span>
		</div>
		{open && <div className="well">
			<WorkCostForm
				isAdmin={props.editUser}
				value={value}
				onChange={(v) => {

					dateControlRef.current.value = v.date?.toISOString() ?? "";
					timeControlRef.current.value = v.time;
					workTypeControlRef.current.value = v.workType;
					additionalCostControlRef.current.value = v.additionalCost;
					descriptionControlRef.current.value = v.description;

					userIdControlRef.current.value = v.user?.value ?? Guid.Empty;
					userLabelControlRef.current.value = v.user?.label ?? "";

					setValue(v);
					if (props.onSet)
						props.onSet(v);
				}}
			/>
		</div>}
	</div>);
}